import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { AttachmentModalComponent } from './attachment-modal/attachment-modal.component';
import { AttachmentModel } from '../shared/model/attachment.model';
import { AttachmentService } from '../shared/service/attachment.service';

@Component({
  selector: 'app-attachment-list',
  templateUrl: './attachment-list.component.html',
  styleUrls: ['./attachment-list.component.css']
})
export class AttachmentListComponent implements OnInit {
  @Input() parent: string;
  @Input() parentId: number;
  @Input() attachments: AttachmentModel[];
  @Output() saved = new EventEmitter<void>();
  @ViewChild(AttachmentModalComponent) modal: AttachmentModalComponent;

  constructor(private attachmentService: AttachmentService) { }

  ngOnInit() {}

  newAttachment(){
    if(this.parent && this.parentId) {
      this.modal.parent = this.parent;
      this.modal.parentId = this.parentId;
      this.modal.display = true;
    }
  }

  onEdit(attachment: AttachmentModel) { 
    this.modal.attachment = attachment;
    this.modal.display = true;
  }

  savedAttachment() {
    this.saved.emit();
  }

  onOpenAttachment(event) { console.log(event); }

  onDelete(attachment: AttachmentModel) { 
    this.attachmentService.delete(attachment.id).subscribe(
      result => {
        this.saved.emit();
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/attachment-list/attachment-list.component.ts